/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortOptionDto } from './SortOptionDto';
import {
    SortOptionDtoFromJSON,
    SortOptionDtoFromJSONTyped,
    SortOptionDtoToJSON,
    SortOptionDtoToJSONTyped,
} from './SortOptionDto';

/**
 * 
 * @export
 * @interface InsuredFilterQueryDto
 */
export interface InsuredFilterQueryDto {
    /**
     * 
     * @type {string}
     * @memberof InsuredFilterQueryDto
     */
    searchText?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof InsuredFilterQueryDto
     */
    statuses?: Array<InsuredFilterQueryDtoStatusesEnum>;
    /**
     * 
     * @type {Array<SortOptionDto>}
     * @memberof InsuredFilterQueryDto
     */
    sortOptions?: Array<SortOptionDto>;
}


/**
 * @export
 */
export const InsuredFilterQueryDtoStatusesEnum = {
    Active: 'Active',
    Inactive: 'Inactive'
} as const;
export type InsuredFilterQueryDtoStatusesEnum = typeof InsuredFilterQueryDtoStatusesEnum[keyof typeof InsuredFilterQueryDtoStatusesEnum];


/**
 * Check if a given object implements the InsuredFilterQueryDto interface.
 */
export function instanceOfInsuredFilterQueryDto(value: object): value is InsuredFilterQueryDto {
    return true;
}

export function InsuredFilterQueryDtoFromJSON(json: any): InsuredFilterQueryDto {
    return InsuredFilterQueryDtoFromJSONTyped(json, false);
}

export function InsuredFilterQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuredFilterQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'searchText': json['searchText'] == null ? undefined : json['searchText'],
        'statuses': json['statuses'] == null ? undefined : json['statuses'],
        'sortOptions': json['sortOptions'] == null ? undefined : ((json['sortOptions'] as Array<any>).map(SortOptionDtoFromJSON)),
    };
}

export function InsuredFilterQueryDtoToJSON(json: any): InsuredFilterQueryDto {
    return InsuredFilterQueryDtoToJSONTyped(json, false);
}

export function InsuredFilterQueryDtoToJSONTyped(value?: InsuredFilterQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'searchText': value['searchText'],
        'statuses': value['statuses'],
        'sortOptions': value['sortOptions'] == null ? undefined : ((value['sortOptions'] as Array<any>).map(SortOptionDtoToJSON)),
    };
}

